import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * ScrollToTop component - scrolls to top on route changes.
 *
 * React Router v6 doesn't automatically scroll to top on navigation.
 * This component listens for pathname changes and scrolls to top.
 *
 * Usage: Place inside <BrowserRouter> but outside <Routes>
 */
export default function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    // Scroll to top on route change
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' // Use 'instant' to avoid jarring smooth scroll on navigation
    })
  }, [pathname])

  return null
}
